module.exports = __webpack_public_path__ + "img/yellow_dot_with_plus.svg";